<template>
  <div class="pa-4">
    <v-card class="mt-2 py-2">
      <v-form
        ref="masterdatamenuform"
        id="masterdatamenuform"
        v-model="valid"
        lazy-validation
      >
        <v-toolbar flat>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical />
          <v-spacer />
          <v-btn
            color="grey"
            dark
            class="mb-2 mr-2"
            @click="$router.go(-1)"
            small
          >
            <v-icon small>mdi-arrow-left</v-icon>
            Back
          </v-btn>
        </v-toolbar>
        <div class="mt-3">
          <v-row class="mx-5">
            <v-col lg="2" md="3" sm="4" cols="4">Menu Name</v-col>
            <v-col lg="2" md="3" sm="8" cols="8">
              <v-text-field
                v-model="menu_name"
                filled
                rounded
                dense
                hide-details="auto"
                :rules="reqRule"
              ></v-text-field>
            </v-col>
            <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
            <v-col lg="2" md="3" sm="8" cols="8">
              <v-select
                outlined
                dense
                hide-details="auto"
                :items="bottles"
                item-value="code"
                item-text="description"
                v-model="selectedBottle"
                @change="handleChangeBottle"
              />
            </v-col>
          </v-row>
          <v-row class="compact-form my-2 mx-1">
            <v-col>
              <v-card outlined>
                <v-skeleton-loader
                  v-if="isLoading"
                  v-bind="attrs"
                  type="table-heading, list-item-two-line, table-tfoot"
                ></v-skeleton-loader>
                <v-simple-table
                  v-else
                  class="spreadsheet-table flex-table"
                  fixed-header
                  height="400"
                  ref="tabelExport"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="header-cell text-center" width="10">No</th>
                        <th class="header-cell text-center">Product</th>
                        <th class="header-cell text-center">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(product, idp) in filteredItems"
                        :key="product.product_code"
                      >
                        <td class="header-cell text-center">{{ idp + 1 }}</td>
                        <td class="header-cell text-no-wrap">
                          {{ product.product_code }}
                          {{ product.product_name }} ({{ product.product_size }}
                          ML)
                        </td>
                        <td class="spreadsheet-cell">
                          <v-text-field
                            v-model="product.quantity"
                            type="number"
                            solo
                            hide-details
                            @wheel="$event.target.blur()"
                            min="0"
                          />
                          <span style="display: none;">{{
                            product.quantity
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colspan="2" class="text-right">Total Quantity</th>
                        <th class="text-center">{{ sumQty || "0" }}</th>
                      </tr>
                    </tfoot>
                  </template>
                </v-simple-table>
              </v-card>
              <v-simple-table class="mt-3">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="header-cell"></th>
                      <th class="header-cell text-center">
                        <span>
                          Total
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(category, i) in productCategories" :key="i">
                      <td class="header-cell">{{ category.name }}</td>
                      <td class="header-cell text-center">
                        {{ calculateCategorySummary(category) }} %
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th class="header-cell"></th>
                      <td class="header-cell text-center font-weight-bold	">
                        {{ calculateTotalCategorySummary() }} %
                      </td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </div>
        <v-card-actions class="pr-4 mt-3 mx-5">
          <v-spacer />
          <v-btn
            depressed
            color="primary"
            @click="saveMasterDataMenu"
            v-if="editedIndex === -1"
          >
            Submit
          </v-btn>
          <v-btn
            depressed
            color="primary"
            @click="updateMasterDataMenu"
            v-if="editedIndex > -1"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-overlay :value="saveProgress" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valid: true,
      isLoading: false,
      isLoadingCoordinator: false,
      dateMenu: false,
      saveProgress: false,
      editedIndex: -1,
      details: [],
      products: [],
      bottles: [],
      selectedBottle: "250",
      editedItem: {},
      menu_name: "",
      items: [],
      reqRule: [(v) => !!v || "Harus diisi!"],
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      productCategories: [],
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    filteredItems() {
      return this.items.filter(
        (item) => item.product_size === this.selectedBottle
      );
    },
    sumQty() {
      if (!this.filteredItems || this.filteredItems.length === 0) return 0;

      return this.filteredItems.reduce((total, product) => {
        const qty = Number(product.quantity);
        return total + (isNaN(qty) ? 0 : qty);
      }, 0);
    },
  },

  async created() {
    this.isLoading = true;

    await this.getDataProducts();

    await this.getBottles();

    await this.fetchDetails();

    await this.getProductCategories();

    this.isLoading = false;
  },

  methods: {
    handelChangeDate() {
      this.fetchDetails();
    },
    handleChangeCoordinator() {
      this.fetchDetails();
    },
    handleChangeBottle() {
      this.items = this.products.map((product) => ({
        product_code: product.code,
        product_name: product.name,
        product_size: product.size,
        product_category_code: product.product_category_code,
        quantity: 0,
      }));
    },
    getBottles() {
      let dataMiscCodes = this.$store.state.misccode.objs;
      this.bottles = dataMiscCodes
        .filter((i) => i.type.includes("Botol"))
        .sort((a, b) => {
          return parseInt(a.code) - parseInt(b.code);
        });
    },
    async getDataProducts() {
      let response = await this.$store.dispatch("variant/getObjs");
      if (response.data.status == "success") {
        this.products = response.data.data;
        this.products = this.products
          .filter((p) => p.is_active == 1)
          .sort((a, b) => a.sort_no - b.sort_no);
        if (this.$route.params.id == "new") {
          this.items = this.products.map((product) => ({
            product_code: product.code,
            product_name: product.name,
            product_size: product.size,
            product_category_code: product.product_category_code,
            quantity: 0,
          }));
        }
      }
    },
    async fetchDetails() {
      if (this.$route.params.id == "new") {
        return;
      }

      this.isLoading = true;

      try {
        const paramId = this.$route.params.id;
        const response = await this.$store.dispatch(
          "masterdatamenu/getObj",
          paramId
        );
        this.menu_name = response.menu_name;
        this.details = response.details;
        this.selectedBottle = response.volume_code;

        this.items = this.products.map((product) => ({
          product_code: product.code,
          product_name: product.name,
          product_size: product.size,
          product_category_code: product.product_category_code,
          quantity: this.qtyFromDetail(product.code),
        }));

        if (response.details.length > 0) {
          this.editedIndex = 1;
        }
      } catch (error) {
        console.log("Error fetching master menu detail:", error);
      } finally {
        this.isLoading = false;
      }
    },
    qtyFromDetail(productCode) {
      let result = 0;
      const detailSelected = this.details.find(
        (product) => product.variant_code == productCode
      );
      if (detailSelected) {
        result = detailSelected.quantity;
      }

      return result;
    },
    isWarning(product) {
      const result = this.calculateSisa(product);
      return result != 0 ? true : false;
    },
    async saveMasterDataMenu() {
      await this.$refs.masterdatamenuform.validate();

      if (!this.valid) return;

      this.saveProgress = true;

      let dataItems = this.convertDataForServer();
      const result = await this.$store.dispatch("masterdatamenu/save", {
        menu_name: this.menu_name,
        volume_code: this.selectedBottle,
        items: dataItems,
      });

      if ((result.status == 200) | (result.status == 201)) {
        // this.$router.go(-1);
        this.$router.push(`/master-data-menu`);
        this.saved = true;
      } else {
        this.saveError = true;
      }

      this.saveProgress = false;
    },
    async updateMasterDataMenu() {
      await this.$refs.masterdatamenuform.validate();
      if (!this.valid) return;

      try {
        this.saveProgress = true;

        let dataItems = this.convertDataForServer();
        const codeId = this.$route.params.id;
        const result = await this.$store.dispatch("masterdatamenu/update", {
          id: codeId,
          menu_name: this.menu_name,
          volume_code: this.selectedBottle,
          items: dataItems,
        });

        if ((result.status == 200) | (result.status == 201)) {
          this.$store.commit("setSnackbar", {
            saveSuccess: true,
            successMessage: "Data tester berhasil diupdate",
          });
          // this.$router.go(-1);
          this.$router.push(`/master-data-menu`);
          this.saved = true;
        } else {
          this.saveError = true;
        }
      } catch (err) {
        const keyword = "duplicate key";
        if (err.response.data.message.search(keyword) > -1) {
          return this.$store.commit("setSnackbar", {
            saveError: true,
            errorMessage: "Duplicate Key!",
          });
        } else {
          return this.$store.commit("setSnackbar", {
            saveError: true,
            errorMessage: err.response.data.message,
          });
        }
      } finally {
        this.saveProgress = false;
      }
    },
    convertDataForServer() {
      let dataItems = [];

      this.items.forEach((item) => {
        dataItems.push({
          variant_code: item.product_code,
          quantity: item.quantity,
        });
      });

      return dataItems;
    },
    async getProductCategories() {
      let response = await this.$store.dispatch("productcategory/getObjs");
      if (response.data.status == "success") {
        this.productCategories = response.data.data;
      }
    },
    calculateCategorySummary(category) {
      const totalPerCategory = this.filteredItems
        .filter((item) => item.product_category_code === category.code)
        .reduce((total, item) => total + Number(item.quantity || 0), 0);

      const totalProduct = this.filteredItems.reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      );

      if (!totalProduct) return 0;

      const percent = (totalPerCategory / totalProduct) * 100;

      return Math.ceil(percent);
    },
    calculateTotalCategorySummary() {
      const total = this.productCategories.reduce(
        (total, item) => total + Number(this.calculateCategorySummary(item)),
        0
      );

      return Math.ceil(total);
    },
  },
};
</script>

<style scoped>
.v-text-field fieldset,
.v-text-field .v-input__control,
.v-text-field .v-input__slot {
  border-radius: 7px !important;
}

.text-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.text-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.text-input .v-input__slot {
  background-color: #ffe169 !important;
  text-align: center;
}

.text-center-input .v-input__slot {
  text-align: center;
}

.text-center-input ::v-deep .v-input__control input {
  text-align: center;
}

.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  background-color: transparent !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.spreadsheet-input .v-input__slot {
  background-color: #ffe169 !important;
  text-align: center;
}

.spreadsheet-cell .v-text-field.v-text-field--solo .v-input__control input {
  text-align: center !important;
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow: hidden;
}

.flex-table {
  display: flex;
  flex-grow: 1;
  width: 100%;
}

.flex-table > div {
  width: 100%;
}

.disable-input input {
  padding: 0 !important;
  border: none;
  background-color: #e0e0e0 !important;
}

.disable-input ::v-deep .v-input__control {
  background-color: #e0e0e0 !important;
}

.disable-input ::v-deep .v-input__slot {
  background-color: #e0e0e0 !important;
}

.disable-input ::v-deep .v-input__control input {
  background-color: #e0e0e0 !important;
}

.disable-input .v-input__slot {
  background-color: #e0e0e0 !important;
}

.disable2-input input {
  padding: 0 !important;
  border: none;
  background-color: #f5f5f5 !important;
}

.disable2-input ::v-deep .v-input__control {
  background-color: #f5f5f5 !important;
}

.disable2-input ::v-deep .v-input__slot {
  background-color: #f5f5f5 !important;
}

.disable2-input ::v-deep .v-input__control input {
  background-color: #f5f5f5 !important;
}

.disable2-input .v-input__slot {
  background-color: #f5f5f5 !important;
}

.warning-input input {
  padding: 0 !important;
  border: none;
  background-color: #fbdade !important;
}

.warning-input ::v-deep .v-input__control {
  background-color: #fbdade !important;
}

.warning-input ::v-deep .v-input__slot {
  background-color: #fbdade !important;
}

.warning-input ::v-deep .v-input__control input {
  background-color: #fbdade !important;
  text-align: center;
}

.warning-input .v-input__slot {
  background-color: #fbdade !important;
  text-align: center;
}

.v-data-table table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
